import React from 'react'
import Header from './Header'
import {Row,Col,ListGroup,Image,Card, Button} from 'react-bootstrap'
import { Link } from 'react-router-dom'
import CheckoutSteps from '../smallcomponent/CheckoutSteps'

import { menuData } from '../data';


function PlaceOrder() {

    const { menuItems } = menuData

    

  
  return (

    <section className=' min-h-[1290px]  lg:min-h-[1800px] bg-testimonial '>

    <Header />

    <CheckoutSteps step1 step2 step3 step4 />

        <Row className=''>
            <div className='mb-8 '>


           <div className='pg-pink-300/20 mb-8 '>
            <Col md={8} className=' mx-[200px]' >

                <ListGroup variant='flush' >

                    <ListGroup.Item className='bg-testimonial mb-8 '>

                        <h2 className='mb-4 text-white text-2xl text-center mt-4'> Shipping Address</h2>

                        <p className = 'mb-4 text-white text-2xl text-center mt-4'>

                          

                            guelma, 140 city
                            {'   '}
                            122,
                            {'   '}
                            algeria

                        </p>

                    </ListGroup.Item>



                    <ListGroup.Item className='bg-testimonial mb-8 '>
                        <h2 className='mb-4 text-white text-2xl text-center mt-4'> Payement Method</h2>
                        <p className='mb-4 text-white text-2xl text-center mt-4'>
                            <strong>Method :</strong>

                           paypal
                        
                        </p>

                    </ListGroup.Item>


                    <ListGroup.Item className=' mb-8 bg-testimonial' >
                        <h2 className='mb-2 text-white text-2xl text-center mt-4'> Order Items </h2>


                            {menuItems.lenght ===0 ? <h1 variant='info'> Your Cart Is Empty  </h1>:
                            (
                                <ListGroup variant='flush' >
                                    {menuItems.map((item,index)=> {

                                          const {image,name}  = item

                                        return <ListGroup.Item key = {index} className='mb-8 mt-10  bg-testimonial pt-10 min-h-[120px] '>
                                            <Row>
                                                <Col md={1}  >
                                                <Image className='mb-4' src = {image} alt = {name}  fluid rounded/>
                                                </Col>

                                                <Col>

                                                    <Link  to='' className='  text-white text-2xl  mt-4'> {name}</Link>
                                                </Col>
                                                <Col md={4}
                                                className='  text-white text-2xl  mt-4'
                                                >
                                                   55 DA

                                                </Col>
                                                

                                            </Row>


                                        </ListGroup.Item>

                                         })}

                                </ListGroup>
                            )
                            }
                            
                        
                    </ListGroup.Item>


                </ListGroup>
            </Col>
            </div>


            <Col md={4}>
                <Card>
                    <ListGroup variant = 'flush'>
                        <ListGroup.Item>
                            <h2> Order Summary</h2>
                        </ListGroup.Item>

                        <ListGroup.Item>
                            <Row>
                            <Col> Item :</Col>
                            <Col>44 DA</Col>


                            </Row>

                        </ListGroup.Item>


                        
                        <ListGroup.Item>
                            <Row>
                            <Col> Shipping :</Col>
                            <Col> 234 DA</Col>


                            </Row>

                        </ListGroup.Item>


                        
                        
                        <ListGroup.Item>
                            <Row>
                            <Col> Tax :</Col>
                            <Col> 23 DA</Col>

                            
                            </Row>

                        </ListGroup.Item>


                        
                        <ListGroup.Item>
                            <Row>
                            <Col> Total :</Col>
                            <Col> 2222 DA</Col>
                            </Row>

                        </ListGroup.Item>

                     

<ListGroup.Item>
    <Button type = 'button' className='btn-block mx-3'> Place Order</Button>


</ListGroup.Item>

                    </ListGroup>
                </Card>

            </Col>
            </div>
        </Row>
      



</section>

  )
}

export default PlaceOrder
